import { SocieteTerritoireSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const SocieteTerritoireModel: SelectorModel = {
  name: 'societeTerritoires',
  getSelector: SocieteTerritoireSelectors.selectAllSocieteTerritoiresDictionary,
  isReady: SocieteTerritoireSelectors.selectIsReadySocieteTerritoire
};
